module.exports = __webpack_public_path__ + "static/valori_2_small-3e3d3acd28331a44d08d53a40f6f3db3.jpg";